export const SHARED_CONFIG = { passingGrade: 75 };
